<template>
  <definition-list ref="definitionList" :isDataSource="'false'"></definition-list>
</template>

<script>

import DefinitionList from './definition-list.vue'

export default {
  name: 'reportDesignList',
  components: {
    DefinitionList
  },
  beforeRouteEnter (to, from, next) {
    if (from.path.includes('/report-design')) {
      next(vm => {
        let _this = vm
        _this.$refs.definitionList.getTableData()
      })
    } else {
      next()
    }
  },
  beforeRouteLeave (to, from, next) {
    // 离开页面关闭弹窗
    this.$refs.definitionList.reportRuntimeDialog.visible = false
    next()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/report/design/report-list.vue